import React from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

const MathShortAnswerDirections: React.FC = () => {
  return (
    <div
      className="max-w-[650px] w-1/2 h-full overflow-auto p-8 bg-white border-r border-gray-200"
      style={{ fontFamily: '"Times New Roman", Times, serif' }}
    >
      <div className="mb-4 font-bold text-lg">
        Student-produced response directions
      </div>
      <ul className="list-disc pl-5 space-y-2 text-[16px]">
        <li>
          If you find <strong>more than one correct answer</strong>, enter only
          one answer.
        </li>
        <li>
          You can enter up to 5 characters for a <strong>positive</strong>{" "}
          answer and up to 6 characters (including the negative sign) for a{" "}
          <strong>negative</strong> answer.
        </li>
        <li>
          If your answer is a <strong>fraction</strong> that doesn't fit in the
          provided space, enter the decimal equivalent.
        </li>
        <li>
          If your answer is a <strong>decimal</strong> that doesn't fit in the
          provided space, enter it by truncating or rounding at the fourth
          digit.
        </li>
        <li>
          If your answer is a <strong>mixed number</strong> (such as
          <span
            className="inline-block align-middle font-bold mx-1"
            dangerouslySetInnerHTML={{
              __html: katex.renderToString("3\\frac{1}{2}"),
            }}
          />
          ), enter it as an improper fraction (7/2) or its decimal equivalent
          (3.5).
        </li>
        <li>
          Don't enter <strong>symbols</strong> such as a percent sign, comma, or
          dollar sign.
        </li>
      </ul>
      <img
        src="/img_sat_math_short_answer_passage.png"
        alt="SAT Math Short Answer Reference"
        className="mt-6 max-w-full mx-auto block"
      />
    </div>
  );
};

export default MathShortAnswerDirections;
